import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/seeker/components/registration/index.tsx");
